import { useStore } from '@nanostores/react';
import { map } from 'nanostores';

export const $demoResetInFlight = map<Record<string, string>>({});

export function markDemoCopyResetting(patientUserId: string, slug: string): void {
  $demoResetInFlight.setKey(patientUserId, slug);
}

export function clearDemoCopyResetting(patientUserId: string): void {
  $demoResetInFlight.setKey(patientUserId, undefined);
}

export function useDemoResetInFlightSlug(patientUserId: string): string | undefined {
  const slugs = useStore($demoResetInFlight, { keys: [patientUserId] });
  return slugs[patientUserId];
}
